import React, { useEffect, useState } from "react"
import { useSearchParams, Link } from "react-router-dom"
import { getAPIBaseURL } from "../services/helpers"
import { getData } from "../services/request"
import logo from "../asset/images/logo.svg"

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams()
  const postId = searchParams.get("postId")
  const txRef = searchParams.get("txRef")
  const [request, setRequest] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (postId) {
      fetchRequest()
    } else {
      setLoading(false)
    }
  }, [postId])

  const fetchRequest = async () => {
    setLoading(true)
    const url = `${getAPIBaseURL()}/v1/posts/${postId}`
    const res = await getData(url, {}, {})
    setLoading(false)
    if (res.error == "") {
      if (res.result.status === 200) {
        setRequest(res.result.data?.data || null)
      }
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <a href="/" className="mb-8 flex items-center justify-center gap-2 text-2xl font-semibold text-gray-900">
            <img className="mr-2 h-8 w-8 -mt-0.5" src={logo} alt="Medpool logo" />
            <span className="leading-none tracking-tight">Medpool</span>
          </a>
        </div>

        <div className="rounded-lg border border-gray-200 bg-white p-8 shadow-sm">
          <div className="mb-6 text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
              <svg className="h-8 w-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="mb-2 text-2xl font-bold text-gray-900">Payment Successful!</h1>
            <p className="text-sm text-gray-600">
              Your payment has been processed successfully.
            </p>
          </div>

          {loading ? (
            <div className="mb-6 text-center text-sm text-gray-500">Loading request details...</div>
          ) : request ? (
            <div className="mb-6 space-y-3 rounded-lg border border-gray-100 bg-gray-50 p-4">
              <div className="flex justify-between text-sm">
                <span className="font-medium text-gray-600">Request ID:</span>
                <span className="text-gray-900">{request._id}</span>
              </div>
              {txRef && (
                <div className="flex justify-between text-sm">
                  <span className="font-medium text-gray-600">Transaction Ref:</span>
                  <span className="text-gray-900 font-mono text-xs">{txRef}</span>
                </div>
              )}
              {request.paymentAmount && (
                <div className="flex justify-between text-sm">
                  <span className="font-medium text-gray-600">Amount Paid:</span>
                  <span className="text-gray-900 font-semibold">₦{Number(request.paymentAmount).toLocaleString()}</span>
                </div>
              )}
              <div className="flex justify-between text-sm">
                <span className="font-medium text-gray-600">Status:</span>
                <span className="rounded-full bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-700">
                  {request.status}
                </span>
              </div>
            </div>
          ) : null}

          <div className="flex flex-col gap-3">
            <Link
              to="/dashboard/requests"
              className="w-full rounded-lg bg-black px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-gray-800"
            >
              View My Requests
            </Link>
            <Link
              to="/dashboard"
              className="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-center text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccess

